var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import queryString from 'query-string';
import React, { Component } from 'react';
import { Container } from 'typedi';
import { config } from '../config';
import { UserManager } from '../services/user';
import { wechatClient } from '../services/wechat';
import { AppError } from './AppError';
import { AppLoading } from './AppLoading';
var AuthWechat = /** @class */ (function (_super) {
    __extends(AuthWechat, _super);
    function AuthWechat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthWechat.prototype.performLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, href, matchs, _a, _b, oAuthCode, search, queryParams, queryStr, _c, combainedQueryString, combainedQueryString, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, , 6]);
                        href = window.location.href;
                        matchs = href.match(/code=([\w\d]+)/);
                        _a = __read(matchs || [], 2), _b = _a[1], oAuthCode = _b === void 0 ? undefined : _b;
                        console.log('APP_START', href, matchs, oAuthCode);
                        search = this.props.location.search;
                        console.log('APP_START', JSON.stringify(this.props));
                        queryParams = queryString.parse(search);
                        // 将oAuthCode转移至Hash后的OAuth参数
                        if (oAuthCode && !queryParams.code) {
                            queryStr = queryString.stringify(__assign({ code: oAuthCode }, queryParams));
                            return [2 /*return*/, window.location.replace(config.BASE_URL + "/#" + this.props.location.pathname + "?" + queryStr)];
                        }
                        if (!queryParams.code) {
                            return [2 /*return*/, Container.get(UserManager).redirectToWechatLogin()];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Container.get(UserManager).loginWithWechat(queryParams.code)];
                    case 2:
                        user = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _c = _d.sent();
                        combainedQueryString = this.removeOAuthQuery(this.props.location);
                        window.location.replace(config.BASE_URL + "/#" + this.props.location.pathname + "?" + combainedQueryString);
                        return [2 /*return*/, window.location.reload()];
                    case 4:
                        // 登录完成，去除OAuth参数
                        if (queryParams.code) {
                            combainedQueryString = this.removeOAuthQuery(this.props.location);
                            this.props.history.replace(this.props.location.pathname + "?" + combainedQueryString);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _d.sent();
                        return [2 /*return*/, this.props.onError(err_1)];
                    case 6: 
                    // 登录完成
                    return [2 /*return*/, this.props.onSuccess(user)];
                }
            });
        });
    };
    AuthWechat.prototype.removeOAuthQuery = function (location) {
        var parsedSearch = queryString.parse(location.search);
        parsedSearch.code = undefined;
        parsedSearch.state = undefined;
        return queryString.stringify(parsedSearch);
    };
    AuthWechat.prototype.render = function () {
        if (!wechatClient.checkIsWechat()) {
            return React.createElement(AppError, { errorMsg: "\u8BF7\u5728\u5FAE\u4FE1\u4E2D\u6253\u5F00" });
        }
        // tslint:disable-next-line:no-floating-promises
        this.performLogin();
        return React.createElement(AppLoading, null);
    };
    return AuthWechat;
}(Component));
export { AuthWechat };
//# sourceMappingURL=AuthWechat.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AuthWechat.js
// module id = 463
// module chunks = 0